import { colord } from "colord";
import svLocale from "dayjs/locale/sv";
import { Calendar } from "frost-ui-react";
import type { CalendarStyles } from "frost-ui-react";
import styled from "styled-components";
import { appTheme } from "@styles/Theme";

interface Props {
	compact?: boolean;
	className?: string;
	value?: Date;
	onChange: (val: Date | undefined) => any;
}

export const DatePicker: React.FC<Props> = ({ compact, className, value, onChange }) => {
	return (
		<Styles className={className}>
			<div className="cal-wrapper">
				<Calendar
					value={value}
					onChange={onChange}
					monthFormat={compact ? "MMM" : "MMMM"}
					focusOnDate={value || new Date()}
					locale={svLocale}
					styles={compact ? compactStyles : defaultStyles}
					weekdayFormat="d"
				/>
			</div>
		</Styles>
	);
};

const Styles = styled.div`
	.cal-wrapper {
		/* margin: 1.5rem 0; */
	}
`;

const defaultStyles: CalendarStyles = {
	highlightStyles: {
		hasJob: {
			backgroundColor: appTheme.colors.brand,
			borderColor: colord(appTheme.colors.brand).darken(0.1).toHex(),
			color: "white",
		},
		today: {
			backgroundColor: "#777",
			borderColor: "black",
			color: "white",
		},
	},
	rangeStyles: {
		disabled: {
			color: "#bbb",
			textDecoration: "line-through",
		},
		range: {
			backgroundColor: "rgba(0, 166, 153, 0.7)",
			color: "white",
			handle: {
				borderColor: "rgb(0, 166, 153)",
			},
		},
	},
	hoverStyles: {
		borderColor: "rgba(0, 166, 153, 0.3)",
	},
};

const compactStyles: CalendarStyles = {
	...defaultStyles,
	dayFontSize: 12,
	weekDayFontSize: 10,
	circleFontSizeRatio: 2.5,
	headerFontSize: 13,
	arrowSize: 13,
	highlightStyles: {
		value: {
			backgroundColor: appTheme.colors.brand,
			borderColor: colord(appTheme.colors.brand).darken(0.1).toHex(),
			color: "white",
		},
		today: {
			backgroundColor: "#777",
			borderColor: "black",
			color: "white",
		},
	},
};
